import React from 'react';
import _ from 'lodash';
import { Card, CardBody, Form } from 'reactstrap';
import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import { Link } from 'react-router-dom';
import history from 'app/routes/history';
import TeamIcon from 'app/images/icons/team.svg';
import SportIcon from 'app/images/icons/sport.svg';
import OrganisationIcon from 'app/images/icons/organisation.svg';
import IActions from 'app/types/actions';
import { IOrganisationsSelector } from 'app/types/selector';
import StepNumberDivider from 'app/components/general/StepNumberDivider';

interface IClubDetailsProps {
  actions: IActions;
  currentOrganisation: any;
  match: any;
  club?: {
    organisationId: string;
    selectedSport: string;
    clubName: string;
  };
  sports: any;
  organisations: IOrganisationsSelector;
}

interface IClubDetailsState {
  name?: string;
  sport?: any;
  organisation?: any;
  errors: any;
}

export default class ClubDetails extends React.Component<
  IClubDetailsProps,
  IClubDetailsState
> {
  static defaultProps: IClubDetailsProps = {
    match: undefined,
    currentOrganisation: undefined,
    sports: [],
    actions: undefined,
    organisations: undefined,
  };

  state: IClubDetailsState = {
    name: '',
    sport:
      _.isEmpty(this.props.club) || _.isEmpty(this.props.club.selectedSport)
        ? this.props.sports[0]
        : this.props.club.selectedSport,
    organisation: undefined,
    errors: [],
  };

  componentDidMount() {
    if (this.props.actions.loadGetStarted) {
      this.props.actions.loadGetStarted();
    }
    if (this.props.actions.getSports) {
      this.props.actions.getSports();
    }
    if (
      !this.props.organisations.isLoading
      && !this.props.organisations.hasLoaded
      && this.props.actions.getAllOrganisations
    ) {
      this.props.actions.getAllOrganisations();
    }
    if (!_.isEmpty(this.props.match.params.orgConnectionCode)) {
      this.props.actions.updateUserData({
        orgConnectionCode: this.props.match.params.orgConnectionCode,
      });
    }
  }

  handleChange = (e): void => {
    delete this.state.errors[e.target.name];

    const state = {
      [e.target.name]: e.target.value,
      errors: this.state.errors,
    };
    this.setState(state);
  };

  handleOrganisationChange = (e): void => {
    delete this.state.errors.organisation;
    if (e && e != null) {
      this.setState({ organisation: e });
    }
    if (e == null) {
      this.setState({ organisation: '' });
    }
  };

  handleSportChange = (e): void => {
    delete this.state.errors.sport;
    if (e && e != null) {
      this.setState({ sport: e });
    }
  };

  handleSubmit = (e): void => {
    e.preventDefault();

    this.props.actions.updateUserData({
      team: {
        clubName: this.state.name,
        selectedSport: this.state.sport.id,
        organisationId: this.state.organisation.id,
      },
      userType: 'club',
    });

    history.push('/get-started/personal');
  };

  render(): React.ReactNode {
    const text = this.props.currentOrganisation !== undefined
      ? `Signing up to ${this.props.currentOrganisation.code} is easy.`
      : 'Signing up is easy.';
    return (
      <div>
        <div className="row">
          <div className="col">
            <div className="instruction-header">
              {text}
              <br />
              Firstly, tell us about your club
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col with-padding">
            <StepNumberDivider number={1} total={4} />
            <Form>
              <InputGroupBlock
                type="text"
                icon={TeamIcon}
                labelText="Club name"
                placeholder="Club name"
                aria-label="Club name"
                autoComplete="off"
                tabIndex="1"
                name="name"
                value={this.state.name}
                onChange={this.handleChange}
              />
              <InputGroupBlock
                type="select"
                icon={SportIcon}
                className="height-50 with-margin-bottom"
                labelText="Sport"
                name="sport"
                placeholder="Sport"
                aria-label="Sport"
                autoComplete="off"
                tabIndex="2"
                value={this.state.sport}
                options={this.props.sports}
                onChange={this.handleSportChange}
              />

              <InputGroupBlock
                type="select"
                icon={OrganisationIcon}
                labelText="Association / League"
                name="organisation"
                className="height-50"
                placeholder="Sports organisation/league"
                aria-label="Sports organisation/league"
                autoComplete="off"
                tabIndex="3"
                clearable
                value={this.state.organisation}
                options={
                  this.props.organisations.organisationsByIdInSelectFormat
                }
                onChange={this.handleOrganisationChange}
              />

              <Button
                className="btn-1 btn-full-width success-sm d-block d-sm-none with-margin-top"
                color="primary"
                tabIndex="6"
                disabled={!this.state.sport || !this.state.name}
                onClick={this.handleSubmit}
              >
                Continue
              </Button>
              <Button
                className="btn-1 btn-full-width success-sm d-none d-sm-block with-margin-top"
                color="primary"
                tabIndex="6"
                disabled={!this.state.sport || !this.state.name}
                onClick={this.handleSubmit}
              >
                Continue to Personal Details
              </Button>
            </Form>
          </div>
        </div>
        <div className="row">
          <div className="col with-margin-top-30 text-center text-grey">
            Already have an account?&nbsp;
            <Link to="/login">Log in</Link>
          </div>
        </div>
      </div>
    );
  }
}
